import { Form, Input } from "antd";

interface Props {
  name: string;
  className?: string;
  placeholder?: string;
  onFinish: (values: any, type: string) => void;
}

const Text = ({ name, className, placeholder, onFinish }: Props) => {

  return (
    <Form.Item name={name} className={className}>
      <Input.Search
        onChange={(e) => onFinish(e, "text")}
        placeholder={placeholder}
      />
    </Form.Item>
  );
};

export default Text;
